import Alert from "@/components/core/alert";
import { Button } from "@/components/core/buttons/button";
import { useModalControl } from "@/components/core/modals/use-modal-controller.ts";
import { useCaseRolloGenerateMutation } from "@/features/case-record/api/queries/case-records-query";
import { IconAlertCircle } from "@tabler/icons-react";

export default function GenerateRolloModal({ caseId }: { caseId: string }) {
	const { closeModal } = useModalControl();
	const rolloGenerationMutation = useCaseRolloGenerateMutation(caseId);

	return (
		<>
			<div className="flex flex-col w-full col-span-12">
				<Alert type="info" allowClose={true} title="Remarks" className="mt-2" icon={<IconAlertCircle size={20} stroke={2} />}>
					This will generate the rollo document for this case. The process may take a few moments depending on the size of the attachments. Please do not close
					this window until it completes.
				</Alert>
			</div>
			<div className="flex flex-row w-full gap-2 mt-4">
				<Button
					className=""
					variant="ghost"
					type="button"
					onClick={() => {
						closeModal();
					}}
				>
					Cancel
				</Button>
				<Button
					loading={rolloGenerationMutation.isPending}
					onClick={async () => {
						const newWindow = window.open("", "_blank");
						const response = await rolloGenerationMutation.mutateAsync();
						const url = response.data?.url || `${window.location.origin}/rollo/${caseId}.pdf`;
						if (newWindow) {
							newWindow.location.href = url;
							newWindow.focus();
						} else {
							window.open(url, "_blank");
					}
					}}
					variant="secondary"
				>
					Generate
				</Button>
			</div>
		</>
	);
}
